import { render } from "./FrmConfectionsForPalletizing.vue?vue&type=template&id=0cc7cab4"
import script from "./FrmConfectionsForPalletizing.vue?vue&type=script&lang=js"
export * from "./FrmConfectionsForPalletizing.vue?vue&type=script&lang=js"

import "./FrmConfectionsForPalletizing.vue?vue&type=style&index=0&id=0cc7cab4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__